"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormModalField = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const date_fns_1 = require("date-fns");
const react_1 = require("react");
const __1 = require("../..");
const Input_1 = require("../Input");
exports.FormModalField = react_1.forwardRef(function Field({ id, field, value, setValue }, ref) {
    switch (field.type) {
        case 'text':
            return (jsx_runtime_1.jsxs(__1.FormGroup, Object.assign({ id: id }, { children: [jsx_runtime_1.jsx(__1.Label, { children: field.label }, void 0),
                    jsx_runtime_1.jsx(__1.TextInput, { ref: ref, value: value !== null && value !== void 0 ? value : '', onChange: e => setValue(id, e.target.value) }, void 0)] }), void 0));
        case 'number':
            return (jsx_runtime_1.jsxs(__1.FormGroup, Object.assign({ id: id }, { children: [jsx_runtime_1.jsx(__1.Label, { children: field.label }, void 0),
                    jsx_runtime_1.jsx(__1.TextInput, { type: "number", ref: ref, value: value !== null && value !== void 0 ? value : '', onChange: e => setValue(id, e.target.value) }, void 0)] }), void 0));
        case 'timestamp':
            const numberValue = typeof value === 'number' ? value : Number(value);
            let val = '';
            try {
                val = date_fns_1.format(numberValue, "yyyy-MM-dd'T'HH:mm");
            }
            catch (e) {
                val = '';
            }
            return (jsx_runtime_1.jsxs(__1.FormGroup, Object.assign({ id: id }, { children: [jsx_runtime_1.jsx(__1.Label, { children: field.label }, void 0),
                    jsx_runtime_1.jsx(__1.TextInput, { type: "datetime-local", ref: ref, value: val, onChange: e => {
                            const val = `${new Date(e.target.value).getTime()}`;
                            setValue(id, val);
                        } }, void 0)] }), void 0));
        case 'select':
            return (jsx_runtime_1.jsxs(__1.FormGroup, Object.assign({ id: id }, { children: [jsx_runtime_1.jsx(__1.Label, { children: field.label }, void 0),
                    jsx_runtime_1.jsxs(__1.SelectInput, Object.assign({ ref: ref, value: value !== null && value !== void 0 ? value : '', onChange: e => setValue(id, e.target.value) }, { children: [jsx_runtime_1.jsx("option", { children: "- Select -" }, void 0),
                            field.options.map(({ value, label }) => (jsx_runtime_1.jsx("option", Object.assign({ value: value }, { children: label }), value)))] }), void 0)] }), void 0));
        case 'checkbox':
            return (jsx_runtime_1.jsx(__1.Box, { children: jsx_runtime_1.jsxs(__1.FormGroup, Object.assign({ checkbox: true, id: id }, { children: [jsx_runtime_1.jsx(Input_1.Input, { id: id, type: "checkbox", ref: ref, checked: !!value, onChange: e => setValue(id, !!e.target.checked) }, void 0),
                        jsx_runtime_1.jsx(__1.Label, { children: field.label }, void 0)] }), void 0) }, void 0));
        case 'file':
            return (jsx_runtime_1.jsxs(__1.FormGroup, Object.assign({ id: id }, { children: [jsx_runtime_1.jsx(__1.Label, { children: field.label }, void 0),
                    jsx_runtime_1.jsx("input", { ref: ref, type: "file", id: id, onChange: e => setValue(id, e.target.files), onFocus: e => e.target.select() }, void 0)] }), void 0));
        case 'custom':
            return (jsx_runtime_1.jsx(__1.Box, { children: field.component({ value: value, setValue: value => setValue(id, value) }, ref) }, void 0));
        default:
            throw new Error('Form field type not implemented: ' + field.type);
    }
});
//# sourceMappingURL=FormModalField.js.map